import Axios, { InternalAxiosRequestConfig } from 'axios';
import { toast } from 'sonner';
import { env } from 'config/env';

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
    if (config.headers) {
        config.headers.Accept = 'application/json';
    }

    config.withCredentials = true;
    return config;
}

export const api = Axios.create({
    baseURL: env.API_URL,
});

api.interceptors.request.use(authRequestInterceptor);
api.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        if (error.response?.status === 401) {
            const currentPath = window.location.pathname;
            const searchParams = new URLSearchParams();
            if (currentPath !== '/authenticate') {
                searchParams.set('redirectTo', currentPath);
                window.location.href = `/authenticate?${searchParams.toString()}`;
            }
        } else if (
            error.response?.status === 400 &&
            error.response?.data.errors
        ) {
            toast.error(
                `Validation errors occurred: ${JSON.stringify(error.response?.data.errors)}`,
            );
        } else if (error.response?.data.message) {
            toast.error(error.response?.data.message);
        } else if (!error.response?.data.requires_new_version) {
            toast.error(
                'An unknown error occurred. Please contact support if the issue persists.',
            );
        }

        return Promise.reject(error);
    },
);

export type ErrorMessageResponse = {
    message: string;
};

export type RequiresNewVersionResponse = {
    requires_new_version: boolean;
};
